import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import DataObjectIcon from '@mui/icons-material/DataObject';
import WidgetsIcon from '@mui/icons-material/Widgets';

export const ICONS = {
  'kind:infrastructure': MiscellaneousServicesIcon as never,
  'kind:content': DataObjectIcon as never,
  'kind:seamless': WidgetsIcon as never,
};
